export interface ConfirmationModalState {
  isOpened: boolean;
}

export const initialState: ConfirmationModalState = {
  isOpened: false,
};
